import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type SessionService from 'walden-trace-app/services/session';

export default class LoginRoute extends Route {
  @service('session') declare sessionService: SessionService;

  async beforeModel(transition: Transition) {
    if (await this.sessionService.isAuthenticated()) {
      return this.sessionService.redirectToAttemptedURL();
    } else if (transition.to?.queryParams?.['attemptedURL']) {
      this.sessionService.setAttemptedUrl(transition.to?.queryParams?.['attemptedURL'] as string);
    }
  }
}
